<template>
  <div>
    <MenuMovilTP />
    <main class="container dkt mb-4 px-0 px-md-3 fc fc3">
      <Titulo
        :titulo1="carrera.nombreCorto"
        :titulo2="nombreCarrera"
        :titulo3="tituloEntregado"
        tipoEncabezado="FICHA_CARRERA_TP"
        :volverA="origenRedirect"
        :datosContacto="datosContactame"
        @descargar="descargarFicha"
      />
      <div class="col mb-3 px-0">
        <div class="px-0">
          <IconosDesktop
            v-if="sede"
            :acreditacion="carrera.acreditacion"
            :acreditado="carrera.acreditado"
            :gratuidad="carrera.gratuidad"
            :sede="sede"
            :web="carrera.contacto.paginaWeb"
            :urlLogo="carrera.codigo"
            :telefono="carrera.contacto.telefono"
            :leyExcepcion="carrera.observacionAcreditacionCNA"
          />
          <IconosMobile
            v-if="sede"
            :acreditacion="carrera.acreditacion"
            :acreditado="carrera.acreditado"
            :gratuidad="carrera.gratuidad"
            :sede="sede"
            :web="carrera.contacto.paginaWeb"
            :urlLogo="carrera.codigo"
            :telefono="carrera.contacto.telefono"
            :leyExcepcion="carrera.observacionAcreditacionCNA"
          />
        </div>
        <DetallesCarreraTP v-if="sede" :carrera="detalleCarrera" />
      </div>
    </main>
    <MenuMovilUni />
  </div>
</template>

<script>
import Titulo from "@/components/generales/paginas/TituloFicha";
import IconosDesktop from "@/components/fichaCarreraTP/IconosDesktop";
import IconosMobile from "@/components/fichaCarreraTP/IconosMobile";
import DetallesCarreraTP from "@/components/fichaCarreraTP/DetallesCarreraTP";
import ApiTecnicoProf from "@/services/ApiTecnicoProf";
import MenuMovilTP from "@/components/generales/menuMovil/TecnicoProfesional";
import MenuMovilUni from "@/components/generales/menuMovil/AdmisionUniversitaria";
import { PdfDocument } from "@/utils/ConstructorPDF.js";
import MixinsIconos from "@/mixins/iconosInstituciones.js";

export default {
  name: "FichaCarreraTP",
  components: {
    Titulo,
    IconosDesktop,
    IconosMobile,
    DetallesCarreraTP,
    MenuMovilTP,
    MenuMovilUni
  },
  mixins: [MixinsIconos],
  data() {
    return {
      carrera: {},
      origenRedirect: ""
    };
  },
  async created() {
    await this.getFicha();
  },
  computed: {
    datosContactame() {
      let datosContacto = {
        codigoIntitucion: this.carrera.codigo,
        codigoSede: this.carrera.sedes ? this.carrera.sedes[0].codigo : "",
        codigoCarrera: this.carrera.sedes
          ? this.carrera.sedes[0].carreras[0].codigo
          : ""
      };
      return datosContacto;
    },
    nombreCarrera() {
      if (this.carrera.sedes) {
        return this.carrera.sedes[0].carreras[0].nombre;
      }
    },
    tituloEntregado() {
      if (this.carrera.sedes) {
        return this.carrera.sedes[0].carreras[0].titulo;
      }
    },
    sede() {
      if (this.carrera.sedes) {
        return this.carrera.sedes[0];
      }
    },
    detalleCarrera() {
      if (this.carrera.sedes) {
        return this.carrera.sedes[0].carreras[0];
      }
    }
  },
  methods: {
    async getFicha() {
      this.$emit("cargar");
      let codigoInstitucion = this.$route.params.idInstitucion;
      let codigoCarrera = this.$route.params.codigoCarrera;
      this.origenRedirect = this.$route.params.origen;
      let data = await ApiTecnicoProf.getFichaCarrera(
        codigoInstitucion,
        codigoCarrera,
        true
      );
      if (data) {
        this.carrera = data;
      }
      this.$emit("cargado");
    },
    descargarFicha() {
      let nombreDocumento = this.carrera.nombre;

      let titulo = {
        institucion: this.carrera.nombreCorto,
        carrera: this.nombreCarrera,
        titulo: this.tituloEntregado
      };

      let iconos = {
        logoInstitucion: this.getBase64Image(this.carrera.logoBase64),
        acreditacion: this.textoAcreditacion(
          "UNIVERSIDAD",
          this.carrera.acreditado,
          this.carrera.acreditacion.anios,
          this.carrera.observacionAcreditacionCNA
        ),
        sede: this.sede.nombre,
        region: this.sede.regionNombreCorto,
        telefono: String(this.carrera.contacto.telefono),
        jornada: this.sede.carreras[0].jornada,
        postulacion: this.sede.carreras[0].estadoPostulacion,
        duracion: `${
          this.sede.carreras[0].duracionFormalPrograma
        } ${this.sede.carreras[0].regimen.charAt(
          0
        )}${this.sede.carreras[0].regimen.slice(1).toLowerCase()}`,
        arancel: this.sede.carreras[0].arancelAnual,
        tipoMoneda: this.sede.carreras[0].tipoMoneda,
        vacantes: String(this.sede.carreras[0].vacantes),
        vacantesPACE: this.sede.carreras[0].vacantesPACE,
        fechaAdmision:
          this.sede.carreras[0].fechaAdmision !== "01/01/2000"
            ? this.sede.carreras[0].fechaAdmision
            : "S/I",
        observacionAcreditacionCNA: this.carrera.observacionAcreditacionCNA,
        acreditacionEspecialPandemiaCNA:
          this.carrera.acreditado && this.carrera.acreditacion.anios === 0
      };

      PdfDocument.init();
      PdfDocument.setTitulo("CARRERA_TP", titulo);
      PdfDocument.setIconosCarreraTP(iconos);
      PdfDocument.setDisclaimersAdicionales(
        iconos.observacionAcreditacionCNA,
        iconos.acreditacionEspecialPandemiaCNA,
        "UNIVERSIDAD"
      );
      PdfDocument.setRequisitosIngreso(this.detalleCarrera);
      PdfDocument.setPerfilEgreso(this.detalleCarrera.perfilEgreso);
      PdfDocument.setEmpleabilidad(
        this.detalleCarrera.porcentajeEmpleabilidad,
        this.detalleCarrera.ingresoPromedioCuartoAnio
      );
      PdfDocument.openSinglePage(nombreDocumento);
      PdfDocument.reset();
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/pages/BuscadoresTP/FichaCarreraTP.vue